import { render } from "./PembawaView.vue?vue&type=template&id=214d1f1d"
import script from "./PembawaView.vue?vue&type=script&lang=js"
export * from "./PembawaView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__